import { fetcher } from '@/shared/api/fetcher';
import useSWR from 'swr';

export function usePhoneMasks() {
  const { data, error, isLoading } = useSWR('/phoneMasks', fetcher);

  return {
    isLoading: isLoading,
    phoneMasks:
      !isLoading && data
        ? data.map((phoneMask) => ({
            ...phoneMask,
            mask: phoneMask.mask.replace(/#/g, '9'),
          }))
        : [],
    isError: error,
  };
}
